import {AsyncPipe, NgIf} from '@angular/common';
import {ChangeDetectionStrategy, Component, Inject, Input, OnInit} from '@angular/core';
import {ValidationErrors} from '@angular/forms';
import {UntilDestroy} from '@ngneat/until-destroy';
import {BehaviorSubject} from 'rxjs';
import {InputHintComponent} from '@sms-ir/ui-components';

import {FORM_ERRORS} from '@shared/services/error-handler';

@UntilDestroy()
@Component({
  selector: 'app-control-error',
  template: `
    <div class="form__error" [class.tw-absolute]="!needSpace" [class.tw-relative]="needSpace">
      <ng-container *ngIf="message$ | async as message">
        <smsir-input-hint *ngIf="message" error>{{ message }}</smsir-input-hint>
      </ng-container>

      <smsir-input-hint *ngIf="isPending">در حال بررسی...</smsir-input-hint>
    </div>
  `,
  styles: [
    `
      :host {
        display: block;
        width: 100%;
        flex: none;
        min-width: 0;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [NgIf, AsyncPipe, InputHintComponent],
})
export class ControlErrorComponent implements OnInit {
  private _controlErrors: ValidationErrors | null = null;

  @Input()
  set controlErrors(value: ValidationErrors | null) {
    this._controlErrors = value;
    this.applyErrors(value);
  }

  get controlErrors(): ValidationErrors | null {
    return this._controlErrors;
  }

  @Input() isPending: boolean = false;
  @Input() needSpace: boolean = true;

  message$ = new BehaviorSubject<string>('');

  constructor(@Inject(FORM_ERRORS) private errors: any,) {
  }

  ngOnInit(): void {
    this.applyErrors(this._controlErrors);
  }

  private applyErrors(controlErrors: ValidationErrors | null): void {
    if (this.isPending) {
      return;
    }

    if (controlErrors) {
      const firstKey = Object.keys(controlErrors)[0];
      const getError = this.errors[firstKey];
      const text = typeof getError === 'function' ? getError(controlErrors[firstKey]) : '';
      this.setError(text);
    } else {
      this.setError('');
    }
  }

  setError(text: string) {
    this.message$.next(text);
  }

}
